import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { timer } from 'rxjs/observable/timer';

@Injectable()
export class TouchEventService {
  private swipeCoord?: [number, number];
  private swipeTime?: number;
  publisher : Subject<any>;

  constructor() 
  {
    this.publisher = new Subject();
   
  }

  

  swipe(e: TouchEvent, when: string): void {
    // console.log(e);
    const coord: [number, number] = [e.changedTouches[0].pageX, e.changedTouches[0].pageY];
    const time = new Date().getTime();

    if (when === 'start') {
      this.swipeCoord = coord;
      this.swipeTime = time;
    }

    else if (when === 'end') {
      const direction = [coord[0] - this.swipeCoord[0], coord[1] - this.swipeCoord[1]];
      const duration = time - this.swipeTime;

      if (duration < 1000 && Math.abs(direction[0]) > 30 && Math.abs(direction[0]) > Math.abs(direction[1] * 3)) {
        const swipe = direction[0] < 0 ? 'next' : 'previous';
        if(swipe === 'next') {
          document.getElementsByClassName('container')[0].classList.add('slide-backward');
          // we just need a little delay right here.
          var tim = timer(500);
          tim.subscribe(t => {
            console.log('calling continue');
            this.publisher.next(swipe);
          })
        }
        if(swipe === 'previous') {
          document.getElementsByClassName('container')[0].classList.add('slide-forward');
          console.log('calling back');
          this.publisher.next(swipe);
        }
      }
    }
  }

}



// WEBPACK FOOTER //
// C:/git/SynergiPartners 7-Eleven Screening/src/app/services/touch-event.service.ts